module.exports = __webpack_public_path__ + "img/chatbot.a12203ff.png";